<div *ngIf="!showTerms" class="">
  <div class="sidebar">
    <div>
      <a [routerLink]="['/']" class="is-flex is-justify-content-center my-4">
        <img
          class="logo is-block mr-1"
          src="../../../assets/baloosoft_logo_light.svg"
        />
      </a>
    </div>
    <div class="select-language">
      <app-select-language class="is-block"></app-select-language>
    </div>
    <div class="menu">
      <ul class="menu-list">
        <li *ngxPermissionsOnly="['PROPERTY_LIST']">
          <a
            [routerLink]="['/properties']"
            [routerLinkActive]="['is-active']"
            translationEditableDirective="PROPERTIES"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
            </svg>
            {{ 'PROPERTIES' | translate }}
          </a>
        </li>
        <li *ngxPermissionsOnly="['COMPOUNDS']">
          <a
            [routerLink]="['/compounds']"
            [routerLinkActive]="['is-active']"
            translationEditableDirective="COMPOUNDS"
          >
            <svg
              width="22px"
              height="21px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M17,16H15V22H12V17H8V22H5V16H3L10,10L17,16M6,2L10,6H9V9H7V6H5V9H3V6H2L6,2M18,3L23,8H22V12H19V9H17V12H15.34L14,10.87V8H13L18,3Z"
              /></svg
            >{{ 'COMPOUNDS' | translate }}
          </a>
        </li>
        <li *ngxPermissionsOnly="['BUSINESS_LIST']">
          <a
            [routerLink]="['/licenses']"
            [routerLinkActive]="['is-active']"
            translationEditableDirective="BUSINESSES"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 -960 960 960"
              width="18px"
              fill="#5f6368"
            >
              <path
                d="m438-338 226-226-57-57-169 169-84-84-57 57 141 141Zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Z"
              />
            </svg>

            {{ 'BUSINESSES' | translate }}</a
          >
        </li>
        <li *ngxPermissionsOnly="['MAP_DASHBOARD']">
          <a
            translationEditableDirective="MAP"
            [routerLink]="['/map']"
            [routerLinkActive]="['is-active']"
          >
            <svg
              width="19px"
              height="19px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
              />
            </svg>
            {{ 'MAP' | translate }}</a
          >
        </li>
        <li *ngxPermissionsOnly="['MAP_ANALYTICS_DASHBOARD']">
          <a
            translationEditableDirective="MAP_ANALYTICS"
            [routerLink]="['/map-analytics']"
            [routerLinkActive]="['is-active']"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="22px"
              viewBox="0 -960 960 960"
              width="22px"
              fill="#5f6368"
            >
              <path
                d="M160-160v-320h160v320H160Zm240 0v-640h160v640H400Zm240 0v-440h160v440H640Z"
              />
            </svg>
            {{ 'MAP_ANALYTICS' | translate }}</a
          >
        </li>
        <li *ngxPermissionsOnly="['DIGITIZATION']">
          <a
            translationEditableDirective="DIGITIZATION"
            [routerLink]="['/digitization']"
            [routerLinkActive]="['is-active']"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="22px"
              viewBox="0 -960 960 960"
              width="22px"
              fill="#5f6368"
            >
              <path
                d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm0-240q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm0-240q-33 0-56.5-23.5T160-720q0-33 23.5-56.5T240-800q33 0 56.5 23.5T320-720q0 33-23.5 56.5T240-640Zm240 0q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Zm240 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640ZM480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm40 240v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L643-160H520Zm263-224 37-39-37-37-38 38 38 38Z"
              />
            </svg>
            {{ 'DIGITIZATION' | translate }}</a
          >
        </li>
        <ng-container *ngIf="!externalDashboardsEnabled">
          <li *ngxPermissionsOnly="['DASHBOARD']">
            <a
              translationEditableDirective="DASHBOARD"
              [routerLink]="['/dashboard']"
              [routerLinkActive]="['is-active']"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="18px"
                viewBox="0 -960 960 960"
                width="18px"
                fill="#5f6368"
              >
                <path
                  d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240v720H200Zm320 0v-360h320v280q0 33-23.5 56.5T760-120H520Zm0-440v-280h240q33 0 56.5 23.5T840-760v200H520Z"
                />
              </svg>
              {{ 'DASHBOARD' | translate }}</a
            >
          </li>
        </ng-container>
        <ng-container *ngIf="!externalDashboardsEnabled">
          <li *ngxPermissionsOnly="['REPORTS_DASHBOARD']">
            <a
              translationEditableDirective="REPORTS"
              [routerLink]="['/reports']"
              [routerLinkActive]="['is-active']"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path
                  d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z"
                /></svg
              >{{ 'REPORTS' | translate }}</a
            >
          </li>
        </ng-container>

        <ng-container *ngIf="externalDashboardsEnabled">
          <li>
            <a
              translationEditableDirective="DASHBOARDS"
              [routerLink]="['/external-dashboards']"
              [routerLinkActive]="['is-active']"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="18px"
                viewBox="0 -960 960 960"
                width="18px"
                fill="#5f6368"
              >
                <path
                  d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240v720H200Zm320 0v-360h320v280q0 33-23.5 56.5T760-120H520Zm0-440v-280h240q33 0 56.5 23.5T840-760v200H520Z"
                /></svg
              >{{ 'DASHBOARDS' | translate }}</a
            >
          </li>
          <li>
            <a
              translationEditableDirective="REPORTS"
              [routerLink]="['/external-reports']"
              [routerLinkActive]="['is-active']"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path
                  d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z"
                /></svg
              >{{ 'REPORTS' | translate }}</a
            >
          </li>
          <li *ngxPermissionsOnly="['MOBILE_DASHBOARD']">
            <a
              translationEditableDirective="MOBILE_DASHBOARD"
              [routerLink]="['/external-mobile-dashboard']"
              [routerLinkActive]="['is-active']"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path
                  d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-120v40h400v-40H280Zm0-80h400v-480H280v480Zm0-560h400v-40H280v40Z"
                /></svg
              >{{ 'MOBILE_DASHBOARD' | translate }}</a
            >
          </li>
        </ng-container>
      </ul>
      <ul class="menu-list">
        <li *ngxPermissionsOnly="['ADMIN_PANEL']">
          <a
            translationEditableDirective="ADMIN"
            [routerLink]="['/admin']"
            [routerLinkActive]="['is-active']"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              height="22px"
              viewBox="0 -960 960 960"
              width="22px"
              fill="currentColor"
            >
              <path
                d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z"
              /></svg
            >{{ 'ADMIN' | translate }}</a
          >
        </li>
      </ul>
    </div>
    <div class="user-panel">
      <div class="media dropdown is-hoverable is-up">
        <div class="media-content">
          <a
            style="color: #4a4a4a"
            class="dropdown-trigger"
            aria-haspopup="true"
            aria-controls="dropdown-menu4"
            [routerLink]="['/profile']"
          >
            {{ firstName[0] }}{{ lastName[0] }}
          </a>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <div class="px-3 pb-2">
                <div
                  style="font-size: 16px; line-height: 0.5"
                  class="is-marginless pt-2 user-fullname"
                >
                  {{ firstName }} {{ lastName }}
                </div>
                <small
                  class="user-email mt-2 is-block"
                  style="font-size: 14px"
                  >{{ email }}</small
                >
              </div>
              <div class="dropdown-item">
                <div class="content user-roles">
                  <ul>
                    <li *ngFor="let role of roles">{{ role }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <alert #logoutAlert (confirm)="logout()" titleTrnKey="ARE_YOU_SURE" />
      <button
        (click)="logoutAlert.fire()"
        class="button is-light is-small is-fullwidth p-1"
        translationEditableDirective="LOGOUT"
      >
        {{ 'LOGOUT' | translate }}
      </button>
    </div>
  </div>
  <div class="page-wrapper ml-auto">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <div
            class="navbar-item navbar-item-search-wrapper"
            [ngClass]="{
              'is-active': currentUrl.includes('/search') || searchVisible,
            }"
            (clickOutside)="handleClickOutside($event)"
          >
            <button
              (click)="searchVisible = !searchVisible"
              class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20px"
                fill="currentColor"
              >
                <path
                  d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                />
              </svg>
              <span
                class="navbar-item-label"
                translationEditableDirective="SEARCH"
                >{{ 'SEARCH' | translate }}</span
              >
            </button>
            <div class="navbar-item-search-popup p-2" *ngIf="searchVisible">
              <search (onSubmit)="searchVisible = false"></search>
            </div>
          </div>
          <div
            class="navbar-item"
            *ngxPermissionsOnly="['AUDIT_LOG_LIST']"
            [ngClass]="{ 'is-active': currentUrl === '/audit-logs' }"
          >
            <a
              [routerLink]="['/audit-logs']"
              class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path
                  d="M824-120 636-308q-41 32-90.5 50T440-240q-90 0-162.5-44T163-400h98q34 37 79.5 58.5T440-320q100 0 170-70t70-170q0-100-70-170t-170-70q-94 0-162.5 63.5T201-580h-80q8-127 99.5-213.5T440-880q134 0 227 93t93 227q0 56-18 105.5T692-364l188 188-56 56ZM397-400l-63-208-52 148H80v-60h160l66-190h60l61 204 43-134h60l60 120h30v60h-67l-47-94-50 154h-59Z"
                />
              </svg>
              <span
                class="navbar-item-label"
                translationEditableDirective="AUDIT_LOGS"
                >{{ 'AUDIT_LOGS' | translate }}</span
              >
            </a>
          </div>
          <div class="navbar-item px-4" *ngxPermissionsOnly="['TRANSLATION']">
            <app-toggle-content-editable></app-toggle-content-editable>
          </div>
          <div
            class="px-5 navbar-item is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
            *ngIf="inactivitySettings.SECURITY_INACTIVITY_TIMER_DISPLAY"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 0 24 24"
              width="20px"
              fill="currentColor"
            >
              <path
                d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z"
              />
            </svg>
            <span class="navbar-item-label">{{
              inactivityTimerCountdownTime | countdown: 'mm:ss'
            }}</span>
          </div>
        </div>
        <div
          class="navbar-end"
          *ngIf="currentUrl.includes('/properties')"
          propertiesTabs
        ></div>
        <div
          class="navbar-end"
          *ngIf="currentUrl.includes('/licenses')"
          licensesTabs
        ></div>
      </div>
    </nav>
    <div class="content">
      <router-outlet></router-outlet>
      <div
        *ngIf="footer"
        class="main-footer pt-4 pb-4 has-text-centered mt-auto"
        [innerHTML]="footer"
      ></div>
    </div>
  </div>
</div>

<div *ngIf="showTerms" class="terms">
  <div class="terms-container">
    <h4 class="terms-title">{{ titleKey | translate }}</h4>
    <div class="terms-content">
      <div class="scrollable" [innerHTML]="termsContent"></div>
    </div>
    <div class="terms-buttons">
      <button
        class="button is-danger is-fullwidth is-outlined"
        (click)="logout()"
      >
        {{ 'DECLINE' | translate }}
      </button>
      <button
        class="button is-danger is-fullwidth"
        [disabled]="termsAccepting"
        (click)="accept()"
      >
        {{ 'ACCEPT' | translate }}
      </button>
    </div>
  </div>
</div>
